// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"1767":"RelatedContent","8143":"NewsListingPage","9815":"NewsPage"}[chunkId] || chunkId) + "_" + {"848":"2d2fd9efd458694b37d1","1767":"97cdf2db73309e40a7ed","8143":"b6c2ef52a5392a2a9bf0","9815":"97cdf2db73309e40a7ed"}[chunkId] + ".css";
};